import React, { useEffect, useState } from "react";
import "./style.scss";
import { getPredefineOptionsList } from "../../../../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Modal } from "react-bootstrap";
import { Paper, Box, Typography, Grid } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import moment from "moment";

const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0,0,0,0.05)",
    // paddingLeft: "10px",
    minHeight: "45px",
    // borderRadius: "var(--curve10)",
    color: "#333",
    // border: "1px solid #bfc0c1",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};
const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "rgba(0,0,0,0.2)",
      // backgroundColor:  isSelected &&isFocused ? "#b499c7" : "#b499c7",

      color: "#000",
    };
  },
};

const useStyles = makeStyles((theme) => ({
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    borderTop: "1px solid lightgray",
    // whiteSpace: "nowrap",
  },
  heading2: {
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "bold",
    color: "#563a96",
    textAlign: "left",
  },
  paragraph2: {
    fontFamily: "Montserrat",
    fontSize: "18px",
    color: "#3e4a59",
    marginTop: "30px",
    textAlign: "left",
  },
  image: {
    boxShadow: theme.shadows[2],
  },
  heading3: {
    fontFamily: "Montserrat",
    fontSize: "20px",
    marginTop: "15px",
    fontWeight: "bold",
    color: "#563a96",
  },
  box1: {
    background: "#3ac2d7",
    width: "100%",
    color: "white",
    minHeight: "34px",
    fontSize: "16px",
    padding: "5px !important",
    borderRadius: "10px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
}));

const StartupDashboard = (props) => {
  const { intentToMentor, modalData: item } = props;
  

  const classes = useStyles();
  const handleClose = () => {
    props.setModalOpen(false);
  };
  return (
    <Modal
      size="xl"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{ borderRadius: "7px" }}
    >
      <Modal.Header className="d-flex ">
        <Modal.Title className="modalHeading">{item?.program_name}</Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close "
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-130px", top: "2px", width: "130px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Grid container spacing={2} style={{ padding: "20px" }}>
          <Grid item className="col-md-8 col-sm-12">
            <Paper
              elevation={2}
              style={{
                marginRight: "0px",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              <Typography className={classes.heading2}>
                Program Description
              </Typography>
              <Typography style={{ textAlign: "left" }}>
                Created By: {item?.mentor_name}
              </Typography>

              <Typography className={classes.paragraph2}>
                {item?.program_desc}
              </Typography>
            </Paper>
          </Grid>
          <Grid item className="col-md-4 col-sm-12 widthcolumn">
            <Paper
              elevation={2}
              style={{
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <img
                src={item?.uploadLogo || hashImage}
                style={{
                  height: "170px",
                  width: "170px",
                  objectFit: "contain",
                  maxHeight: "none",
                  maxWidth: "none",
                  borderRadius: "10px",
                  marign: "auto",
                }}
                className={classes.image}
              />
              <Typography className={classes.heading3}>
                Cohort Start Date
              </Typography>
              <Box className={classes.box1} style={{ textAlign: "center" }}>
                {moment(item?.cohort_date).format("Do MMMM YYYY")}
              </Box>
              <Typography className={classes.heading3}>
                Cohort Duration
              </Typography>
              <Box className={classes.box1} style={{ textAlign: "center" }}>
                {item?.program_duration} Months
              </Box>
              <Typography className={classes.heading3}>Organization</Typography>
              <Box className={classes.box1} style={{ textAlign: "center" }}>
                {item?.organization_name}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
})(withRouter(StartupDashboard));
